import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const CardContainerStyle = styled.div`
  margin: 35px 35px 0px 35px;
  padding: 20px;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 5px;

  @media (max-width: 600px) {
    padding: 10px;
    margin: 10px 10px 0px 10px;
  }
`;

const NameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin: 50px 0px 0px 0px;
`;

const ArrowC = styled.div`
  display: flex;
  align-items: center;
`;

const ArrowBackIcon = styled(InnoIcons.ArrowBackIcon)`
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
`;

const Name = styled.span``;

const CustomStepperContainer = styled.div`
  margin: 0px 0px 30px 0px;
`;

const ButtonContaiiner = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin: 50px 0px 0px 0px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    margin-top: 30px;
  }
`;

const SC = {
  BodyHeader,
  CardContainerStyle,
  NameContainer,
  ArrowC,
  ArrowBackIcon,
  Name,
  CustomStepperContainer,
  ButtonContaiiner,
};

export default SC;
